"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _DataResponse = _interopRequireDefault(require("../models/DataResponse"));

var _DataSecurableResponse = _interopRequireDefault(require("../models/DataSecurableResponse"));

var _Storable = _interopRequireDefault(require("../models/Storable"));

var _PagedResponse = _interopRequireDefault(require("../models/PagedResponse"));

var _PagedSecurableResponse = _interopRequireDefault(require("../models/PagedSecurableResponse"));

var _ReportResponse = _interopRequireDefault(require("../models/ReportResponse"));

var _Stream = _interopRequireDefault(require("../models/Stream"));

/**
 * Person service.
 * @module ChiRhos/api/PersonApi
 * @version v1
 */
var PersonApi =
/*#__PURE__*/
function () {
  /**
   * Constructs a new PersonApi.
   * @alias module:ChiRhos/api/PersonApi
   * @class
   * @param {module:ChiRhos/ApiClient} [apiClient] Optional API client implementation to use,
   * default to {@link module:ChiRhos/ApiClient#instance} if unspecified.
   */
  function PersonApi(apiClient) {
    (0, _classCallCheck2["default"])(this, PersonApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }
  /**
   * @param {Object} opts Optional parameters
   * @param {module:ChiRhos/models/ApiMembershipRequest} opts.request
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataResponse} and HTTP response
   */


  (0, _createClass2["default"])(PersonApi, [{
    key: "_acceptGroupMembershipWithHttpInfo",
    value: function _acceptGroupMembershipWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Person/Membership/Group/Accept', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiMembershipRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataResponse}
     */

  }, {
    key: "AcceptGroupMembership",
    value: function AcceptGroupMembership(opts) {
      return this._acceptGroupMembershipWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {String} opts.secret
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/IDataSecurableResponseIStorableIPerson} and HTTP response
     */

  }, {
    key: "_acceptInviteWithHttpInfo",
    value: function _acceptInviteWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        secret: opts['secret']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataSecurableResponse["default"];
      return this.apiClient.callApi('/api/Person/Invite/Accept', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {String} opts.secret
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/IDataSecurableResponseIStorableIPerson}
     */

  }, {
    key: "AcceptInvite",
    value: function AcceptInvite(opts) {
      return this._acceptInviteWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRawRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataSecurableResponse} and HTTP response
     */

  }, {
    key: "_activateWithHttpInfo",
    value: function _activateWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataSecurableResponse["default"];
      return this.apiClient.callApi('/api/Person/Activate', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRawRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataSecurableResponse}
     */

  }, {
    key: "Activate",
    value: function Activate(opts) {
      return this._activateWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiMembershipRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataResponse} and HTTP response
     */

  }, {
    key: "_activateGroupMembershipWithHttpInfo",
    value: function _activateGroupMembershipWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Person/Membership/Group/Activate', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiMembershipRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataResponse}
     */

  }, {
    key: "ActivateGroupMembership",
    value: function ActivateGroupMembership(opts) {
      return this._activateGroupMembershipWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRawRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "_addFavouriteWithHttpInfo",
    value: function _addFavouriteWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/Person/Favourite/Add', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRawRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "AddFavourite",
    value: function AddFavourite(opts) {
      return this._addFavouriteWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiMembershipRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataResponse} and HTTP response
     */

  }, {
    key: "_addGroupMembershipWithHttpInfo",
    value: function _addGroupMembershipWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Person/Membership/Group/Add', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiMembershipRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataResponse}
     */

  }, {
    key: "AddGroupMembership",
    value: function AddGroupMembership(opts) {
      return this._addGroupMembershipWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiMembershipRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataResponse} and HTTP response
     */

  }, {
    key: "_addGroupTypeMembershipWithHttpInfo",
    value: function _addGroupTypeMembershipWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Person/Membership/GroupType/Add', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiMembershipRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataResponse}
     */

  }, {
    key: "AddGroupTypeMembership",
    value: function AddGroupTypeMembership(opts) {
      return this._addGroupTypeMembershipWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {String} opts.entityId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "_deleteWithHttpInfo",
    value: function _deleteWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        entityId: opts['entityId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/Person', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {String} opts.entityId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "Delete",
    value: function Delete(opts) {
      return this._deleteWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
     * @param {Object} opts Optional parameters
     * @param {String} opts.contentType
     * @param {String} opts.contentDisposition
     * @param {Object.<String, {String: String}>} opts.headers
     * @param {Number} opts.length
     * @param {String} opts.name
     * @param {String} opts.fileName
     * @param {String} opts.importIdentifier
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/Storable} and HTTP response
     */

  }, {
    key: "_importWithHttpInfo",
    value: function _importWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        ContentType: opts['contentType'],
        ContentDisposition: opts['contentDisposition'],
        Headers: opts['headers'],
        Length: opts['length'],
        Name: opts['name'],
        FileName: opts['fileName'],
        importIdentifier: opts['importIdentifier']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _Storable["default"];
      return this.apiClient.callApi('/api/Person/Import', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
     * @param {Object} opts Optional parameters
     * @param {String} opts.contentType
     * @param {String} opts.contentDisposition
     * @param {Object.<String, {String: String}>} opts.headers
     * @param {Number} opts.length
     * @param {String} opts.name
     * @param {String} opts.fileName
     * @param {String} opts.importIdentifier
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/Storable}
     */

  }, {
    key: "Import",
    value: function Import(opts) {
      return this._importWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRawRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataSecurableResponse} and HTTP response
     */

  }, {
    key: "_deactivateWithHttpInfo",
    value: function _deactivateWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataSecurableResponse["default"];
      return this.apiClient.callApi('/api/Person/Deactivate', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRawRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataSecurableResponse}
     */

  }, {
    key: "Deactivate",
    value: function Deactivate(opts) {
      return this._deactivateWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiMembershipRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataResponse} and HTTP response
     */

  }, {
    key: "_deactivateGroupMembershipWithHttpInfo",
    value: function _deactivateGroupMembershipWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Person/Membership/Group/Deactivate', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiMembershipRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataResponse}
     */

  }, {
    key: "DeactivateGroupMembership",
    value: function DeactivateGroupMembership(opts) {
      return this._deactivateGroupMembershipWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {String} opts.entityId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "_deleteResourceWithHttpInfo",
    value: function _deleteResourceWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        entityId: opts['entityId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/Person/Resource/Delete', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {String} opts.entityId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "DeleteResource",
    value: function DeleteResource(opts) {
      return this._deleteResourceWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {String} opts.entityId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/ReportResponse} and HTTP response
     */

  }, {
    key: "_executeReportWithHttpInfo",
    value: function _executeReportWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        entityId: opts['entityId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _ReportResponse["default"];
      return this.apiClient.callApi('/api/Person/Membership/Report/Execute', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {String} opts.entityId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/ReportResponse}
     */

  }, {
    key: "ExecuteReport",
    value: function ExecuteReport(opts) {
      return this._executeReportWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataSecurableResponse} and HTTP response
     */

  }, {
    key: "_getWithHttpInfo",
    value: function _getWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataSecurableResponse["default"];
      return this.apiClient.callApi('/api/Person/Get', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataSecurableResponse}
     */

  }, {
    key: "Get",
    value: function Get(opts) {
      return this._getWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @return {Error} The GetOwned() method is depricated, use the Owned() POST method instead.
     */

  }, {
    key: "GetOwned",
    value: function GetOwned() {
      return new Error('The GetOwned() method is depricated, use the Owned() POST method instead.');
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/Stream} and HTTP response
     */

  }, {
    key: "_getResourceFileWithHttpInfo",
    value: function _getResourceFileWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _Stream["default"];
      return this.apiClient.callApi('/api/Person/Resource/File', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/Stream}
     */

  }, {
    key: "GetResourceFile",
    value: function GetResourceFile(opts) {
      return this._getResourceFileWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataResponse} and HTTP response
     */

  }, {
    key: "_getSelfWithHttpInfo",
    value: function _getSelfWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Person/GetSelf', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataResponse}
     */

  }, {
    key: "GetSelf",
    value: function GetSelf() {
      return this._getSelfWithHttpInfo().then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiHistoryRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/IDataResponseIEnumerableActivity} and HTTP response
     */

  }, {
    key: "_historyWithHttpInfo",
    value: function _historyWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Person/History', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiHistoryRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/IDataResponseIEnumerableActivity}
     */

  }, {
    key: "History",
    value: function History(opts) {
      return this._historyWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
     * @param {Object} opts Optional parameters
     * @param {String} opts.contentType
     * @param {String} opts.contentDisposition
     * @param {Object.<String, {String: String}>} opts.headers
     * @param {Number} opts.length
     * @param {String} opts.name
     * @param {String} opts.fileName
     * @param {String} opts.importIdentifier
     * @param {Boolean} opts.createDependencies  (default to false)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/Storable} and HTTP response
     */

  }, {
    key: "_importMembershipsWithHttpInfo",
    value: function _importMembershipsWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        ContentType: opts['contentType'],
        ContentDisposition: opts['contentDisposition'],
        Headers: opts['headers'],
        Length: opts['length'],
        Name: opts['name'],
        FileName: opts['fileName'],
        importIdentifier: opts['importIdentifier'],
        createDependencies: opts['createDependencies']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _Storable["default"];
      return this.apiClient.callApi('/api/Person/Membership/Group/Import', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
     * @param {Object} opts Optional parameters
     * @param {String} opts.contentType
     * @param {String} opts.contentDisposition
     * @param {Object.<String, {String: String}>} opts.headers
     * @param {Number} opts.length
     * @param {String} opts.name
     * @param {String} opts.fileName
     * @param {String} opts.importIdentifier
     * @param {Boolean} opts.createDependencies  (default to false)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/Storable}
     */

  }, {
    key: "ImportMemberships",
    value: function ImportMemberships(opts) {
      return this._importMembershipsWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * This sends an invite to this person to take ownership of this person record.
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRawRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/IDataSecurableResponseIStorableIPerson} and HTTP response
     */

  }, {
    key: "_inviteWithHttpInfo",
    value: function _inviteWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataSecurableResponse["default"];
      return this.apiClient.callApi('/api/Person/Invite', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * This sends an invite to this person to take ownership of this person record.
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRawRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/IDataSecurableResponseIStorableIPerson}
     */

  }, {
    key: "Invite",
    value: function Invite(opts) {
      return this._inviteWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * This sends an invite to the person with this email address.
     * @param {Object} opts Optional parameters
     * @param {String} opts.email
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/IDataSecurableResponseIStorableIPerson} and HTTP response
     */

  }, {
    key: "_inviteByEmailWithHttpInfo",
    value: function _inviteByEmailWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        email: opts['email']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataSecurableResponse["default"];
      return this.apiClient.callApi('/api/Person/Invite/Email', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * This sends an invite to the person with this email address.
     * @param {Object} opts Optional parameters
     * @param {String} opts.email
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/IDataSecurableResponseIStorableIPerson}
     */

  }, {
    key: "InviteByEmail",
    value: function InviteByEmail(opts) {
      return this._inviteByEmailWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityPagedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/PagedResponse} and HTTP response
     */

  }, {
    key: "_listForGroupWithHttpInfo",
    value: function _listForGroupWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _PagedResponse["default"];
      return this.apiClient.callApi('/api/Person/ListForGroup', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityPagedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/PagedResponse}
     */

  }, {
    key: "ListForGroup",
    value: function ListForGroup(opts) {
      return this._listForGroupWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityPagedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/PagedResponse} and HTTP response
     */

  }, {
    key: "_listForGroupTypeWithHttpInfo",
    value: function _listForGroupTypeWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _PagedResponse["default"];
      return this.apiClient.callApi('/api/Person/ListForGroupType', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityPagedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/PagedResponse}
     */

  }, {
    key: "ListForGroupType",
    value: function ListForGroupType(opts) {
      return this._listForGroupTypeWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityPagedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/PagedResponse} and HTTP response
     */

  }, {
    key: "_listInactiveWithHttpInfo",
    value: function _listInactiveWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _PagedResponse["default"];
      return this.apiClient.callApi('/api/Person/ListInactive', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityPagedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/PagedResponse}
     */

  }, {
    key: "ListInactive",
    value: function ListInactive(opts) {
      return this._listInactiveWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityWithDeletedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataResponse} and HTTP response
     */

  }, {
    key: "_listNotesWithHttpInfo",
    value: function _listNotesWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Person/Note/List', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityWithDeletedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataResponse}
     */

  }, {
    key: "ListNotes",
    value: function ListNotes(opts) {
      return this._listNotesWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/IDataResponseIEnumerableIStorableIReport} and HTTP response
     */

  }, {
    key: "_listReportWithHttpInfo",
    value: function _listReportWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Person/Membership/Report/List', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/IDataResponseIEnumerableIStorableIReport}
     */

  }, {
    key: "ListReport",
    value: function ListReport(opts) {
      return this._listReportWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityPagedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/PagedSecurableResponse} and HTTP response
     */

  }, {
    key: "_listResourcesWithHttpInfo",
    value: function _listResourcesWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _PagedSecurableResponse["default"];
      return this.apiClient.callApi('/api/Person/Resource/List', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityPagedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/PagedSecurableResponse}
     */

  }, {
    key: "ListResources",
    value: function ListResources(opts) {
      return this._listResourcesWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * Note that the Order and Sort are ignored for this call as it is ordered by ranking
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiSearchPagedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/PagedResponse} and HTTP response
     */

  }, {
    key: "_lookupWithHttpInfo",
    value: function _lookupWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _PagedResponse["default"];
      return this.apiClient.callApi('/api/Person/Lookup', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * Note that the Order and Sort are ignored for this call as it is ordered by ranking
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiSearchPagedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/PagedResponse}
     */

  }, {
    key: "Lookup",
    value: function Lookup(opts) {
      return this._lookupWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiPagedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/PagedResponse} and HTTP response
     */

  }, {
    key: "_notificationsInWithHttpInfo",
    value: function _notificationsInWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _PagedResponse["default"];
      return this.apiClient.callApi('/api/Person/Notifications/In', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiPagedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/PagedResponse}
     */

  }, {
    key: "NotificationsIn",
    value: function NotificationsIn(opts) {
      return this._notificationsInWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiPagedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/PagedResponse} and HTTP response
     */

  }, {
    key: "_notificationsOutWithHttpInfo",
    value: function _notificationsOutWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _PagedResponse["default"];
      return this.apiClient.callApi('/api/Person/Notifications/Out', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiPagedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/PagedResponse}
     */

  }, {
    key: "NotificationsOut",
    value: function NotificationsOut(opts) {
      return this._notificationsOutWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiPagedFilteredRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataResponse} and HTTP rOsponse
     */

  }, {
    key: "_ownedWithHttpInfo",
    value: function _ownedWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _PagedResponse["default"];
      return this.apiClient.callApi('/api/Person/Owner/ListOwned', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiPagedFilteredRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/PagedResponse}
     */

  }, {
    key: "Owned",
    value: function Owned(opts) {
      return this._ownedWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/PersonConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataSecurableResponse} and HTTP response
     */

  }, {
    key: "_saveWithHttpInfo",
    value: function _saveWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['value'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataSecurableResponse["default"];
      return this.apiClient.callApi('/api/Person', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/PersonConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataSecurableResponse}
     */

  }, {
    key: "Save",
    value: function Save(opts) {
      return this._saveWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * Pass in a multipart form with two parameters: file [File] and resourceJson [Text], with the resourceJson holding a ResourceConstruct (note that the Limit.IsOpen is the only security that is checked for a Person&#39;s resources)
     * @param {Object} opts Optional parameters
     * @param {String} opts.contentType
     * @param {String} opts.contentDisposition
     * @param {Object.<String, {String: String}>} opts.headers
     * @param {Number} opts.length
     * @param {String} opts.name
     * @param {String} opts.fileName
     * @param {String} opts.resourceJson
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataSecurableResponse} and HTTP response
     */

  }, {
    key: "_saveResourceWithHttpInfo",
    value: function _saveResourceWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        ContentType: opts['contentType'],
        ContentDisposition: opts['contentDisposition'],
        Headers: opts['headers'],
        Length: opts['length'],
        Name: opts['name'],
        FileName: opts['fileName'],
        resourceJson: opts['resourceJson']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataSecurableResponse["default"];
      return this.apiClient.callApi('/api/Person/Resource/Save', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * Pass in a multipart form with two parameters: file [File] and resourceJson [Text], with the resourceJson holding a ResourceConstruct (note that the Limit.IsOpen is the only security that is checked for a Person&#39;s resources)
     * @param {Object} opts Optional parameters
     * @param {String} opts.contentType
     * @param {String} opts.contentDisposition
     * @param {Object.<String, {String: String}>} opts.headers
     * @param {Number} opts.length
     * @param {String} opts.name
     * @param {String} opts.fileName
     * @param {String} opts.resourceJson
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataSecurableResponse}
     */

  }, {
    key: "SaveResource",
    value: function SaveResource(opts) {
      return this._saveResourceWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * Recreates the unique code for a person which can be used to, for example, check in for an event
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataSecurableResponse} and HTTP response
     */

  }, {
    key: "_recreateUniqueCodeWithHttpInfo",
    value: function _recreateUniqueCodeWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataSecurableResponse["default"];
      return this.apiClient.callApi('/api/Person/RecreateUniqueCode', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * Recreates the unique code for a person which can be used to, for example, check in for an event
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataSecurableResponse}
     */

  }, {
    key: "RecreateUniqueCode",
    value: function RecreateUniqueCode(opts) {
      return this._recreateUniqueCodeWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiMembershipRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataResponse} and HTTP response
     */

  }, {
    key: "_removeGroupMembershipWithHttpInfo",
    value: function _removeGroupMembershipWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Person/Membership/Group/Remove', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiMembershipRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataResponse}
     */

  }, {
    key: "RemoveGroupMembership",
    value: function RemoveGroupMembership(opts) {
      return this._removeGroupMembershipWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiMembershipRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataResponse} and HTTP response
     */

  }, {
    key: "_removeGroupTypeMembershipWithHttpInfo",
    value: function _removeGroupTypeMembershipWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Person/Membership/GroupType/Remove', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiMembershipRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataResponse}
     */

  }, {
    key: "RemoveGroupTypeMembership",
    value: function RemoveGroupTypeMembership(opts) {
      return this._removeGroupTypeMembershipWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {String} opts.entityId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "_restoreWithHttpInfo",
    value: function _restoreWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        entityId: opts['entityId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/Person/Restore', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {String} opts.entityId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "Restore",
    value: function Restore(opts) {
      return this._restoreWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * The Filters collection will filter the Groups, the property filters will filter the Persons
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ReportConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/ReportResponse} and HTTP response
     */

  }, {
    key: "_runReportWithHttpInfo",
    value: function _runReportWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['value'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _ReportResponse["default"];
      return this.apiClient.callApi('/api/Person/Membership/Report/Run', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * The Filters collection will filter the Groups, the property filters will filter the Persons
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ReportConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/ReportResponse}
     */

  }, {
    key: "RunReport",
    value: function RunReport(opts) {
      return this._runReportWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ReportConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "_saveReportWithHttpInfo",
    value: function _saveReportWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['value'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/Person/Membership/Report/Save', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ReportConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "SaveReport",
    value: function SaveReport(opts) {
      return this._saveReportWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ReportConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "_saveReportForGroupTypeWithHttpInfo",
    value: function _saveReportForGroupTypeWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['value'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/Person/Membership/Report/SaveForGroupType', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ReportConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "SaveReportForGroupType",
    value: function SaveReportForGroupType(opts) {
      return this._saveReportForGroupTypeWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiAddOwnerRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataSecurableResponse} and HTTP response
     */

  }, {
    key: "_transferOwnershipWithHttpInfo",
    value: function _transferOwnershipWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataSecurableResponse["default"];
      return this.apiClient.callApi('/api/Person/Owner/Add', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiAddOwnerRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataSecurableResponse}
     */

  }, {
    key: "TransferOwnership",
    value: function TransferOwnership(opts) {
      return this._transferOwnershipWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * Wipes a person&#39;s sensitive personal details. CANNOT BE REVERSED.
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "_wipeWithHttpInfo",
    value: function _wipeWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/Person/Wipe', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * Wipes a person&#39;s sensitive personal details. CANNOT BE REVERSED.
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "Wipe",
    value: function Wipe(opts) {
      return this._wipeWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
  }]);
  return PersonApi;
}();

exports["default"] = PersonApi;
module.exports = exports.default;